import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = ['https://cdn.magicpatterns.com/uploads/uDp4a45EpqqbTfZG2NjCE2/ChatGPT-Image-7-jul-2026_-10_27_58.webp', 'https://cdn.magicpatterns.com/uploads/reFqbFcZxPx9rzVoihJYwM/ChatGPT-Image-7-jul-2026_-10_30_28.webp', 'https://cdn.magicpatterns.com/uploads/f2gciSXzDmbQBQLRE7KjUR/ChatGPT-Image-7-jul-2026_-10_34_21.webp', 'https://cdn.magicpatterns.com/uploads/cM6UNXE9FdsnurJ6dyzZMm/ChatGPT-Image-7-jul-2026_-10_43_44.webp'];
  // Duplicamos la lista para lograr un loop continuo sin cortes.
  const track = [...testimonials, ...testimonials];
  return <section className="py-20 bg-slate-50 overflow-hidden" data-id="element-155">
      <div className="max-w-6xl mx-auto px-4" data-id="element-156">
        <div className="text-center mb-12" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-158">
            Testimonios reales
          </h2>
          <p className="text-lg text-slate-600" data-id="element-159">
            Lo que dicen clientes que ya lo usan
          </p>
        </div>
      </div>

      {/* Carrusel continuo derecha -> izquierda */}
      <div className="relative" data-id="element-160">
        {/* Fades laterales */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-r from-slate-50 to-transparent z-10" data-id="element-161" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-24 bg-gradient-to-l from-slate-50 to-transparent z-10" data-id="element-162" />

        <motion.div className="flex gap-4 md:gap-6 w-max" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 20,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-163">
          {track.map((src, index) => <div key={index} className="w-56 md:w-64 flex-shrink-0 rounded-2xl overflow-hidden bg-white border border-slate-200 shadow-sm" data-id="element-164">
              <img src={src} alt={`Testimonio de un cliente por WhatsApp`} loading="lazy" className="w-full h-full object-cover" data-id="element-165" />
            </div>)}
        </motion.div>
      </div>

      <div className="max-w-6xl mx-auto px-4" data-id="element-166">
        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mt-14 max-w-2xl mx-auto" data-id="element-167">
          <div className="text-center" data-id="element-168">
            <div className="text-3xl md:text-4xl font-black text-blue-600 mb-1" data-id="element-169">
              500+
            </div>
            <div className="text-sm text-slate-600 font-medium" data-id="element-170">Clientes</div>
          </div>
          <div className="text-center border-x border-slate-200" data-id="element-171">
            <div className="text-3xl md:text-4xl font-black text-blue-600 mb-1" data-id="element-172">
              4.9
            </div>
            <div className="text-sm text-slate-600 font-medium" data-id="element-173">
              Calificación
            </div>
          </div>
          <div className="text-center" data-id="element-174">
            <div className="text-3xl md:text-4xl font-black text-blue-600 mb-1" data-id="element-175">
              100%
            </div>
            <div className="text-sm text-slate-600 font-medium" data-id="element-176">
              Satisfacción
            </div>
          </div>
        </div>
      </div>
    </section>;
}